import React from 'react'

import type { ColorScheme } from '../../types'
import { FileAudioIcon } from '../Icon/FileAudioIcon'
import { FileIcon } from '../Icon/FileIcon'
import { FileSpreadsheetIcon } from '../Icon/FileSpreadsheetIcon'
import { FileTextIcon } from '../Icon/FileTextIcon'
import { FilmIcon } from '../Icon/FilmIcon'

/**
 * Last dot-suffix of a file name, lowercased; '' when there is none. A
 * leading-dot name ('.env') has no extension.
 */
export const getExtension = (name: string): string => {
  const dotIndex = name.lastIndexOf('.')
  if (dotIndex <= 0 || dotIndex === name.length - 1) return ''
  return name.slice(dotIndex + 1).toLowerCase()
}

/**
 * Glyph for a file extension. Monochrome semantic-token colored by design —
 * the rebrand drops the legacy react-icons brand colors (pdf red, word blue).
 * Extensions mirror the set incident notes accept (ENG-32108).
 */
export const getFileTypeIcon = (
  extension: string,
  colorScheme: ColorScheme
): React.ReactNode => {
  switch (extension) {
    case 'doc':
    case 'docx':
    case 'pdf':
    case 'txt':
      return <FileTextIcon colorScheme={colorScheme} size={20} />
    case 'csv':
      return <FileSpreadsheetIcon colorScheme={colorScheme} size={20} />
    case 'mp3':
    case 'wav':
      return <FileAudioIcon colorScheme={colorScheme} size={20} />
    case 'mp4':
    case 'mov':
    case 'mpg':
    case 'mpeg':
      return <FilmIcon colorScheme={colorScheme} size={20} />
    default:
      return <FileIcon colorScheme={colorScheme} size={20} />
  }
}
